import { render, staticRenderFns } from "./top-events-card.vue?vue&type=template&id=3c5d995b&scoped=true&"
import script from "./top-events-card.vue?vue&type=script&lang=js&"
export * from "./top-events-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5d995b",
  null
  
)

export default component.exports